import * as React from 'react';
import styled from 'styled-components';
import { display, DisplayProps } from 'styled-system';
import { ContentContainer } from '@packages/ui';
import { CmsSlotName, Page as AppPage, CmsPage as Page, Page as PageType } from '@packages/common';
import { SideEffectsContext, PageContext } from '@packages/shared';
import { CMSBreadcrumbs } from '../CmsModule/CMSBreadcrumbs/CMSBreadcrumbs';

// todo:fix the commented code.

import { CmsSlot } from '../CmsSlot/CmsSlot';
// import { CmsContextProvider } from 'providers/CmsContext/CmsContext';

// row-module uses negative margins for building the grid ->
// using overflow:hidden here prevents the container going past 100% width
const FluidWidthContainerStyled = styled(ContentContainer)<DisplayProps>`
  padding-right: 0;
  padding-left: 0;
  flex-direction: column;
  overflow: hidden;
  ${display}
`;

// display container as flex-element for xs-m to be able to flip the order (-> Breadcrumbs order-prop)
// and display breadcrumbs at the bottom on mobile/tablet
const DISPLAY = ['flex', 'flex', 'flex', 'block'];

export type CmsPageProps = {
  page?: Page;
};

export const CmsPage: React.FC<CmsPageProps> = ({ page }) => {
  const { marketing } = React.useContext(SideEffectsContext);
  const { pageType } = React.useContext(PageContext);

  React.useEffect(() => {
    if (page && pageType !== AppPage.category) {
      marketing({
        quantityOfProducts: 0,
        remarketingProductID: [],
        pageType: window.location.pathname === '/' ? PageType.home : pageType,
      });
    }
  }, [marketing, pageType, page]);
  return page ? (
    <FluidWidthContainerStyled display={DISPLAY} id="cms-page-content">
      <CMSBreadcrumbs breadcrumbs={page?.breadcrumbs} customBreadcrumbs={page?.customBreadcrumbs} />
      {/* <CmsContextProvider> */}
      <CmsSlot modules={page?.modules ? page.modules[CmsSlotName.MAIN] : []} />
      {/* </CmsContextProvider> */}
    </FluidWidthContainerStyled>
  ) : null;
};
